import { EntityRequest } from "../entity/EntityRequest";
import { DtoApiPager } from "./abst/DtoApiPager";
import { DtoRequestCostsacctsGetRes } from "./abst/DtoRequestCostsacctsGetRes";

export class DtoRequestCostsacctsGetResImple extends DtoRequestCostsacctsGetRes {
  public request = new EntityRequest();
  
  public pager = new DtoApiPager();
}
